import React from "react";
import { ChargeFormApiProps } from "../types";
import { RateSheetProvider } from "./RateSheetProvider";
import { ChargeFormStateProvider } from "./ChargeFormStateProvider";
import { FinalFormBoundary } from "./FinalFormBoundary";
import { useForm } from "react-final-form";

/**
 * Captures final-form's `FormApi` and nests the form-scoped providers around its
 * children; holds no state of its own. See the `charge-form-editor-providers`
 * spec.
 */
export const ChargeFormApiProvider: React.FC<ChargeFormApiProps> = (props) => {
  const { children, charge, values } = props;

  const formApi = useForm();

  return (
    <FinalFormBoundary formApi={formApi}>
      <RateSheetProvider>
        <ChargeFormStateProvider charge={charge} values={values}>
          {children}
        </ChargeFormStateProvider>
      </RateSheetProvider>
    </FinalFormBoundary>
  );
};
